import React from "react";
import { Link } from "react-router-dom";

const HeaderTopbar = () => {
  return (
    <div className="topbar">
      <div className="container-fluid">
        <div className="row">
          <div className="col col-md-8 col-sm-12 col-12">
            <div className="contact-intro">
              <ul>
<li>
                  <i className="fi flaticon-email-1"></i>
                  <a href="mailto:demo@example.com">
                    taisha4eriecounty@gmail.com
                  </a>
                </li>
                <li>
                  <i className="fi ti-location-pin"></i>
                  PO Box 13, Buffalo, NY 14201
                </li>
              </ul>
            </div>
          </div>
          <div className="col col-md-4 col-sm-12 col-12">
            <div className="contact-info">
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=61568623033330"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <i className="ti-facebook"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/taishaforeriecounty"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter"
                  >
                    <i className="ti-twitter-alt"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/taishaforeriecounty"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <i className="ti-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderTopbar;
